import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importRewardsAndCreditsContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "RewardsAndCreditsContainer" */
                '@perpay-web/fintech/components/containers/RewardsAndCreditsContainer'
            ),
    );
